import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcLgt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "4.75 2.75 14.5 18.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M 6,4 L 6,12 C 10,16 14,16 18,12 L 18,4 M 12,10 L 12,20",
			stroke: "white",
			strokeWidth: 2.5,
			fill: "none"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M 6,4 L 6,12 C 10,16 14,16 18,12 L 18,4 M 12,10 L 12,20",
			stroke: "green",
			fill: "none"
		})]
	})
});
export default SvgIcLgt;
